import AlertList from "./AlertList";

export default AlertList;
